 <template>
  <div class="payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsDataComputed" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-yinhangka"></use>
      </svg>
    </breadcrumbs>
    <noticeTool />
    <div class="content">
      <div class="tabs">
        <div class="tabs-title tabs-title--sticky">
          <span>{{ st('finance.paymentMethodCreditCardTitle') }}</span>
          <artmisads-button :isSquare="true" type="primary" class="add-new-card-button" @click="bindCard">
            <Icon name="jiahao" /> {{ st('finance.paymentMethodAddNewCard') }}
          </artmisads-button>
        </div>
        <a-spin :spinning="cardListBlockLoading" class="card-list-spin">
          <div class="card-list" :class="{ 'card-list--only-empty': cardList.length === 0 && !cardListBlockLoading }">
            <template v-if="cardList.length > 0">
              <div class="card-item" v-for="item in cardList" :key="item.instrumentId || item.id || item.bindRequestId">
                <div class="card-item-top">
                  <img class="card-item-top-text" src="../../../../assets/images/img/cardText.png" alt="">

                  <a-dropdown :trigger="['click']">
                    <div class="card-item-top-more">
                      ···
                    </div>
                    <template #overlay>
                      <a-menu @click="handleMenuClick($event, item, 'CARD')">
                        <a-menu-item key="0">
                          {{ st('cpcCreate.remove') }}
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
                <div class="card-item-bottom">
                  {{ formatCardPanDigits(item.maskedCardNo || item.cardNoMasked || '') }}
                  <!-- {{ item.maskedCardNo || item.cardNoMasked || '' }} -->
                </div>
              </div>
            </template>
            <template v-else>
              <a-empty :description="st('finance.paymentMethodEmptyNoCard')" />
            </template>
          </div>
        </a-spin>

      </div>
      <div class="tabs">

        <div class="tabs-title tabs-title--sticky">
          <span>{{ st('finance.paymentMethodAlipay') }}</span>
          <artmisads-button :loading="alipayBindLoading" @click="bindAlipay" :isSquare="true" type="primary"
            class="add-new-card-button">
            <Icon name="jiahao" /> {{ st('finance.paymentMethodAddNewAccount') }}
          </artmisads-button>
        </div>
        <a-spin :spinning="alipayListBlockLoading" class="card-list-spin">
          <div class="card-list"
            :class="{ 'card-list--only-empty': alipayList.length === 0 && !alipayListBlockLoading }">
            <template v-if="alipayList.length > 0">
              <div class="card-item-aliPay card-item " v-for="item in alipayList" :key="item.id">
                <div class="card-item-top">
                  <img class="card-item-top-text" style="width: 42px;height: 42px;"
                    src="../../../../assets/images/img/alipayIcon.png" alt="">
                  <!-- <div class="card-item-top-more" @click="openUnbindModal(item, 'ALIPAY_CN')">
                    ···
                  </div> -->
                  <a-dropdown :trigger="['click']">
                    <div class="card-item-top-more">
                      ···
                    </div>
                    <template #overlay>
                      <a-menu @click="handleMenuClick($event, item, 'ALIPAY_CN')">
                        <a-menu-item key="0">
                          {{ st('cpcCreate.remove') }}
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
                <div class="card-item-bottom">
                  {{ maskEmail(item?.userLoginId) }}
                </div>
              </div>
            </template>
            <template v-else>
              <a-empty :description="st('finance.paymentMethodEmptyNoAlipay')" />
            </template>
          </div>
        </a-spin>

      </div>
    </div>
    <div class="footer-bottom-container">
    <div class="footer-bottom">
      <span class="footer-bottom-text">{{ st('finance.paymentMethodTechSupport') }}</span>
      <img class="footer-bottom-img" src="../../../../assets/images/img/footOne.png" alt="">
      <img style="height:30px" src="../../../../assets/images/img/footTwo.png" alt="">
    </div>
    <div>
      <Table />
    </div>
   </div>
    <artmisads-modal v-model:open="showUnbindModal" :title="st('finance.unbindAuthModalTitle')" :width="480"
      :destroyOnClose="true" :onCancel="closeUnbindModal">
      <p>{{ st('finance.unbindAuthModalContent') }}</p>
      <template #footer>
        <artmisads-button @click="closeUnbindModal">{{ st('common.cancel') }}</artmisads-button>
        <artmisads-button type="primary" :loading="unbindSubmitting" @click="confirmUnbind">{{ st('common.confirm')
        }}</artmisads-button>
      </template>
    </artmisads-modal>
    <unbindContactModal v-model:open="showUnbindContactModal" />
  </div>
</template>
<script setup>
import { message } from "ant-design-vue"
import { ref, onMounted, onBeforeUnmount, watch, computed } from "vue"
import { useRoute } from "vue-router"
import { useSellerI18n } from '@/composables/useSellerI18n'
import breadcrumbs from "@/pages/seller/breadcrumbs.vue"
import { financeApi } from "~/server"
import noticeTool from './components/noticeTool.vue'
import Icon from '@/components/Icon.vue'
import Table from './components/table.vue'
import unbindContactModal from './components/unbindContactModal.vue'
import { AMSAutoDebit, AMSAutoDebitPay, AMSCashierPayment, AMSEasyPay, AMSVaulting } from "@alipay/ams-checkout"
import { useUserInfoStore } from '@/storeData/index';
const store = useUserInfoStore()
const { st, locale } = useSellerI18n()
const route = useRoute()
const showUnbindContactModal = ref(false)

const hasRouteAuthCode = () => {
  const v = route.query.authCode
  if (v === undefined || v === null) {
    return false
  }
  const s = Array.isArray(v) ? v[0] : v
  return typeof s === "string" && s.length > 0
}
const resolveCheckoutLocale = () => {
  if (locale.value === "zh-CN") {
    return "zh_CN"
  }
  return "en_US"
}
const breadcrumbsDataComputed = computed(() => ({
  title: st('finance.paymentMethodPageTitle'),
  color: 'rgba(250, 172, 38, 1)',
  links: [
    {
      name: st('common.home'),
      path: "/seller/dashboard",
    },
    {
      name: st('finance.breadcrumbFinance'),
      path: "/seller/finance/payments",
    },
    {
      name: st('finance.paymentMethodBreadcrumbPayments'),
      path: "/seller/finance/paymentMethod",
    },
  ],
}))
/** 卡号展示：纯数字 15 位 3-4-4-4、16 位 4-4-4-4；含 * 的掩码（如 405469******0768）保留 * 后每 4 位分组 */
const formatCardPanDigits = (input) => {
  const raw = String(input ?? '').trim()
  if (!raw) {
    return ''
  }
  if (raw.includes('*')) {
    const panLike = raw.replace(/[^\d*]/g, '')
    if (!panLike) {
      return ''
    }
    const parts = []
    for (let i = 0; i < panLike.length; i += 4) {
      parts.push(panLike.slice(i, i + 4))
    }
    return parts.join(' ')
  }
  const digits = raw.replace(/\D/g, '')
  if (!digits) {
    return ''
  }
  if (digits.length === 15) {
    return [digits.slice(0, 3), digits.slice(3, 7), digits.slice(7, 11), digits.slice(11, 15)].join(' ')
  }
  if (digits.length === 16) {
    return [digits.slice(0, 4), digits.slice(4, 8), digits.slice(8, 12), digits.slice(12, 16)].join(' ')
  }
  const parts = []
  let rest = digits
  while (rest.length > 4) {
    parts.push(rest.slice(0, 4))
    rest = rest.slice(4)
  }
  if (rest) {
    parts.push(rest)
  }
  return parts.join(' ')
}

/** 邮箱脱敏：本地部分前 4 + **** + 后 2，域名原样，如 363948255@qq.com → 3639****55@qq.com */
const maskEmail = (input) => {
  const email = String(input ?? '').trim()
  if (!email) {
    return ''
  }
  const at = email.lastIndexOf('@')
  if (at <= 0 || at === email.length - 1) {
    return email
  }
  const local = email.slice(0, at)
  const domain = email.slice(at + 1)
  const n = local.length
  if (n <= 1) {
    return `*@${domain}`
  }
  if (n <= 2) {
    return `${local[0]}*@${domain}`
  }
  if (n <= 4) {
    return `${local[0]}****@${domain}`
  }
  if (n < 6) {
    return `${local.slice(0, 2)}****${local.slice(-1)}@${domain}`
  }
  return `${local.slice(0, 4)}****${local.slice(-2)}@${domain}`
}

const cardList = ref([])
const cardListBlockLoading = ref(false)
const alipayList = ref([])
const alipayListBlockLoading = ref(false)
const showUnbindModal = ref(false)
const unbindSubmitting = ref(false)
const pendingUnbind = ref(null)
const openUnbindModal = (record, instrumentKind) => {
  pendingUnbind.value = { record, instrumentKind }
  showUnbindModal.value = true
}
const handleMenuClick = (event, record, instrumentKind) => {
  pendingUnbind.value = { record, instrumentKind }
  console.log(store.userInfo, 'store.userInfo')
  if(store.userInfo.paymentUnbindRestricted === 'Y') {
    showUnbindContactModal.value = true
  } else {
    showUnbindModal.value = true
  }
  // showUnbindModal.value = true
}
const closeUnbindModal = () => {
  showUnbindModal.value = false
  pendingUnbind.value = null
}
const confirmUnbind = async () => {
  if (!pendingUnbind.value) {
    return
  }
  const { record, instrumentKind } = pendingUnbind.value

  unbindSubmitting.value = true
  try {
    await financeApi.financeSellerBankInstrumentUnbind({
      bindId: record.id

    })
    message.success(st('finance.unbindSuccess'))
    closeUnbindModal()
    if (instrumentKind === 'CARD') {
      await getCardList({ withBlockLoading: true })
    } else {
      await getAlipayList({ withBlockLoading: true })
    }

  } catch (error) {
    console.error('financeSellerBankInstrumentUnbind failed:', error)
    // message.error(error?.message)
  } finally {
    unbindSubmitting.value = false
  }
}
const alipayCheckout = ref()
const alipayCheckoutSdkName = ref("AMSEasyPay")
const alipayCheckoutConfig = ref(null)
const alipayCheckoutLoading = ref(false)
const alipayBindLoading = ref(false)
const normalizeBankBindStartResponse = (response) => {
  const rawData = response?.data || response
  return normalizeCheckoutConfig({
    ...rawData,
    paymentSessionData: rawData?.paymentSessionData || rawData?.sessionData || rawData?.vaultingSessionData,
    sessionData: rawData?.sessionData || rawData?.paymentSessionData || rawData?.vaultingSessionData,
    requestId: rawData?.requestId || rawData?.bindRequestId,
  })
}
const bindAlipay = async () => {
  if (alipayBindLoading.value) {
    return
  }
  alipayBindLoading.value = true
  try {
    const response = await financeApi.financeSellerBankBindStart({
      provider: "ANTOM",
      instrumentKind: "ALIPAY_CN",
    })
    const url = response?.data?.normalUrl
    if (!url) {
      message.warning(response?.data?.error || response?.error || st('finance.paymentMethodMissingBindUrl'))
      return
    }
    window.open(url, '_blank')
    console.log("[DashboardCheckout] financeSellerBankBindStart response:", response)
  } catch (error) {
    console.error('financeSellerBankBindStart (Alipay) failed:', error)
    message.error(error?.message || st('finance.paymentMethodFailedStartAlipayBind'))
  } finally {
    alipayBindLoading.value = false
  }
}
const bindCard = async () => {
  if (alipayCheckoutLoading.value) {
    return
  }
  alipayCheckoutLoading.value = true
  try {
    if (!alipayCheckoutConfig.value) {
      const response = await financeApi.financeSellerBankBindStart({
        provider: "ANTOM",
        instrumentKind: "CARD",
      })

      const nextConfig = normalizeBankBindStartResponse(response)
      if (!nextConfig) {
        message.warning(response?.error || st('finance.paymentMethodMissingCheckoutSession'))
        return
      }
      if (alipayCheckout.value) {
        alipayCheckout.value.unmount()
        alipayCheckout.value = undefined
      }
      alipayCheckoutConfig.value = nextConfig
    }
    const isReady = initAlipayCheckout()
    if (!isReady) {
      return
    }
    const { paymentSessionData, merchantAppointParam, notRedirectAfterComplete } = alipayCheckoutConfig.value
  
    await alipayCheckout.value.createComponent({
      paymentSessionData,
      merchantAppointParam,
      notRedirectAfterComplete,
    })
  } catch (error) {
    console.error("Failed to open Alipay checkout:", error)
    message.error(error?.message || st('finance.paymentMethodFailedOpenCheckout'))
  } finally {
    alipayCheckoutLoading.value = false
  }
}
const decodeCheckoutSessionMeta = (paymentSessionData) => {
  if (!paymentSessionData || typeof window === "undefined") {
    return null
  }
  try {
    const encodedMeta = paymentSessionData.split("&&")[3]
    if (!encodedMeta) {
      return null
    }
    return JSON.parse(window.atob(encodedMeta))
  } catch (error) {
    console.warn("Failed to decode checkout session metadata:", error)
    return null
  }
}
const resolveCheckoutSdk = (paymentSessionData) => {
  const sessionMeta = decodeCheckoutSessionMeta(paymentSessionData)
  const productScene = sessionMeta?.paymentSessionConfig?.productScene

  if (productScene === "VAULTING") {
    return { sdkName: "AMSVaulting", sdkClass: AMSVaulting }
  }
  if (productScene === "CASHIER_PAYMENT") {
    return { sdkName: "AMSCashierPayment", sdkClass: AMSCashierPayment }
  }
  if (productScene === "AUTO_DEBIT") {
    return { sdkName: "AMSAutoDebit", sdkClass: AMSAutoDebit }
  }
  if (productScene === "AUTO_DEBIT_PAY") {
    return { sdkName: "AMSAutoDebitPay", sdkClass: AMSAutoDebitPay }
  }

  return { sdkName: "AMSEasyPay", sdkClass: AMSEasyPay }
}
const resolveSecurityRegionFromSession = (paymentSessionData) => {
  const region = getSessionParts(paymentSessionData)[1]
  if (["SG", "US", "DE"].includes(region)) {
    return region
  }
  return undefined
}
const initAlipayCheckout = () => {
  if (!alipayCheckoutConfig.value) {
    return false
  }
  if (alipayCheckout.value) {
    return true
  }
  try {
    const { environment, locale, redirectUrl, merchantId, securityRegion, paymentSessionData } = alipayCheckoutConfig.value
    const { sdkClass, sdkName } = resolveCheckoutSdk(paymentSessionData)
    alipayCheckoutSdkName.value = sdkName
    const options = {
      environment,
      locale,
      redirectUrl,
      securityRegion,
      onError: (error) => {
        console.error("[DashboardCheckout] onError:", error)
      },
      onEventCallback: (event) => {
        console.log("[DashboardCheckout] onEventCallback:", event)
        if (event.code === 'SDK_ASSET_BINDING_SUCCESSFUL'|| event.code === 'SDK_ASSET_BINDING_PROCESSING') {
          pollCardListUntilUpdated()
        }
        if (event.code === 'SDK_ASSET_BINDING_FAIL') {
          message.error(st('finance.paymentMethodCardBindFailed'))
        }
      },
      onClose: (...args) => {
        console.log("[DashboardCheckout] onClose:", args)
        // getCardList()
      },
      onLog: (log) => {
        console.log("[DashboardCheckout] onLog:", log)
      },
    }
    if (merchantId) {
      options.merchantId = merchantId
    }
    console.log("[DashboardCheckout] init checkout:", { sdkName, environment, locale, redirectUrl, merchantId, securityRegion })
    alipayCheckout.value = new sdkClass(options)
    return true
  } catch (error) {
    console.error("Failed to initialize Alipay checkout:", error)
    message.error(st('finance.paymentMethodFailedInitCheckout'))
    return false
  }
}
const getSessionParts = (paymentSessionData) => {
  if (!paymentSessionData || typeof paymentSessionData !== "string") {
    return []
  }
  return paymentSessionData.split("&&")
}
const normalizeCheckoutConfig = (config) => {
  if (!config) {
    return null
  }
  const paymentSessionData = config.paymentSessionData || config.sessionData
  if (!paymentSessionData) {
    return null
  }
  // prod on production site https://www.artemisads.com ; otherwise sandbox
  const checkoutEnvFromHost =
    typeof window !== "undefined" && window.location.origin === "https://www.artemisads.com"
      ? "prod"
      : "sandbox"
  console.log(checkoutEnvFromHost, 'checkoutEnvFromHost', window.location.origin)

  return {
    paymentSessionData,
    environment: config.environment || checkoutEnvFromHost,
    locale: config.locale || resolveCheckoutLocale(),
    // redirectUrl: config.redirectUrl || `${window.location.origin}/seller/payResult`,
    merchantId: config.merchantId,
    securityRegion: config.securityRegion || resolveSecurityRegionFromSession(paymentSessionData) || "SG",
    buttonText: config.buttonText || st('finance.paymentMethodOpenCheckout'),
    merchantAppointParam: config.merchantAppointParam,
    notRedirectAfterComplete: config.notRedirectAfterComplete !== false,
    autoOpen: Boolean(config.autoOpen),
  }
}
const getCardList = async (opts = {}) => {
  const { withBlockLoading = false } = opts
  if (withBlockLoading) {
    cardListBlockLoading.value = true
  }
  try {
    const response = await financeApi.financeSellerBankInstrumentList({
      page: 1,
      pageSize: 100,
      instrumentKind: "CARD",
      provider: "ANTOM",
      status: 'ACTIVE',
    })
    cardList.value = response.data.data
    console.log("[DashboardCheckout] financeSellerBankInstrumentList response:", response)
  } finally {
    if (withBlockLoading) {
      cardListBlockLoading.value = false
    }
  }
}

const CARD_LIST_POLL_INTERVAL_MS = 2000
const CARD_LIST_POLL_MAX_ATTEMPTS = 30
let cardListPollTimer = null

const stopCardListPoll = () => {
  if (cardListPollTimer != null) {
    clearTimeout(cardListPollTimer)
    cardListPollTimer = null
  }
}

let alipayListPollTimer = null

const stopAlipayListPoll = () => {
  if (alipayListPollTimer != null) {
    clearTimeout(alipayListPollTimer)
    alipayListPollTimer = null
  }
}

/** 绑卡成功后后端列表可能延迟，轮询列表直到条数增加或超时 */
const pollCardListUntilUpdated = () => {
  stopCardListPoll()
  cardListBlockLoading.value = true
  const baselineLength = cardList.value.length
  let attempts = 0

  const run = async () => {
    attempts += 1
    try {
      await getCardList()
    } catch (e) {
      console.error("[DashboardCheckout] poll getCardList:", e)
    }
    const nextLen = Array.isArray(cardList.value) ? cardList.value.length : 0
    if (nextLen > baselineLength) {
      cardListBlockLoading.value = false
      stopCardListPoll()
      return
    }
    if (attempts >= CARD_LIST_POLL_MAX_ATTEMPTS) {
      cardListBlockLoading.value = false
      stopCardListPoll()
      message.warning(st('finance.paymentMethodCardBindDelayed'))
      return
    }
    cardListPollTimer = window.setTimeout(() => void run(), CARD_LIST_POLL_INTERVAL_MS)
  }

  void run()
}

/** 支付宝授权回调后列表可能延迟，轮询直到条数增加或超时（与绑卡轮询逻辑一致） */
const pollAlipayListUntilUpdated = () => {
  stopAlipayListPoll()
  alipayListBlockLoading.value = true
  const baselineLength = Array.isArray(alipayList.value) ? alipayList.value.length : 0
  let attempts = 0

  const run = async () => {
    attempts += 1
    try {
      await getAlipayList()
    } catch (e) {
      console.error("[DashboardCheckout] poll getAlipayList:", e)
    }
    const nextLen = Array.isArray(alipayList.value) ? alipayList.value.length : 0
    if (nextLen > baselineLength) {
      alipayListBlockLoading.value = false
      stopAlipayListPoll()
      return
    }
    if (attempts >= CARD_LIST_POLL_MAX_ATTEMPTS) {
      alipayListBlockLoading.value = false
      stopAlipayListPoll()
      message.warning(st("finance.paymentMethodAlipayBindDelayed"))
      return
    }
    alipayListPollTimer = window.setTimeout(() => void run(), CARD_LIST_POLL_INTERVAL_MS)
  }

  void run()
}

const getAlipayList = async (opts = {}) => {
  const { withBlockLoading = false } = opts
  if (withBlockLoading) {
    alipayListBlockLoading.value = true
  }
  try {
    const response = await financeApi.financeSellerBankInstrumentList({
      page: 1,
      pageSize: 100,
      instrumentKind: "ALIPAY_CN",
      provider: "ANTOM",
      status: 'ACTIVE',
    })
    alipayList.value = response.data.data
    console.log("[DashboardCheckout] financeSellerBankInstrumentList response:", response)
  } finally {
    if (withBlockLoading) {
      alipayListBlockLoading.value = false
    }
  }
}
onMounted(async () => {
  await getCardList({ withBlockLoading: true })
  if (hasRouteAuthCode()) {
    pollAlipayListUntilUpdated()
  } else {
    await getAlipayList({ withBlockLoading: true })
  }
})

onBeforeUnmount(() => {
  stopCardListPoll()
  stopAlipayListPoll()
  cardListBlockLoading.value = false
  alipayListBlockLoading.value = false
})
</script>
<style lang="less" scoped>
:deep(.footer) {
  display: none !important;
}

.footer-bottom {
  display: flex;
  align-items: center;

  .footer-bottom-text {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 0.9);
  }

  .footer-bottom-img {
    height: 30px;
    margin: 0 16px 0 8px;
  }
}

.payments {
  padding: 0 16px;
  .footer-bottom-container{
    padding:0 16px;
  }
  .content {
    overflow: hidden;

    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;

    .tabs {
      flex: 1;
      width: 0px;
      min-height: 430px;
      max-height: 430px;
      overflow: auto;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0px 2px 8px 0px #00000014;
      padding: 0 16px;
      box-shadow: 0px 1px 0px 0px #0F06290D;

      .tabs-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--border-4);
        padding: 0 0 16px 0;

        &--sticky {
          position: sticky;
          top: 0;
          z-index: 2;
          background-color: #fff;
          padding-top: 16px;
        }

        >span {
          font-family: Sora;
          font-weight: 600;
          font-size: 20px;
          leading-trim: NONE;
          line-height: 28px;
          letter-spacing: 0.5px;
          color: #0F0629;
        }

        .add-new-card-button {
          background-color: rgba(114, 64, 255, 0.14);
          font-family: Sora;
          font-weight: 500;
          font-style: Medium;
          font-size: 14px;
          leading-trim: NONE;
          line-height: 20px;
          letter-spacing: 0.4px;
          color: rgba(15, 6, 41, 1);
          display: flex;
          gap: 8px;
          align-items: center;
        }
      }

      .card-list-spin {
        display: block;
        width: 100%;

        :deep(.ant-spin-container) {
          min-height: 200px;
        }
      }

      .card-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        margin-top: 16px;
        margin-bottom: 16px;

        &--only-empty {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 300px;
        }

        .card-item-aliPay {
          background-image: url('../../../../assets/images/img/alipay.png') !important;
          background-size: 118% 118% !important;
          overflow: hidden !important;
        }

        .card-item {
          display: flex;
          flex-direction: column;
          min-width: 0;
          padding: 16px;
          background-image: url('../../../../assets/images/img/card.png');
          height: 130px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          border-radius: 10px;
          overflow: hidden !important;

          .card-item-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-width: 0;
            gap: 8px;

            .card-item-top-text {
              height: 24px;
              width: 74px;
            }

            .card-item-top-more {
              background: #fff;
              width: 26px;
              height: 24px;
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              width: 18;
              border: 1px solid rgba(204, 199, 217, 1);
              box-shadow: 0px 1px 0px 0px rgba(15, 6, 41, 0.05);

            }
          }

          .card-item-bottom {
            font-family: Alibaba PuHuiTi 3.0;
            font-weight: 600;
            font-style: 75 SemiBold;
            font-size: 22px;
            leading-trim: NONE;
            color: #fff;
            letter-spacing: 0px;
            margin-top: auto;
            min-width: 0;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.card-bind-spin {
  align-self: flex-start;

  :deep(.ant-spin-container) {
    transition: opacity 0.2s;
  }

  :deep(.ant-spin-blur) {
    opacity: 0.72;
    pointer-events: none;
    user-select: none;
  }
}

.card-bind-indicator {
  display: inline-block;
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  border: 3px solid rgba(250, 172, 38, 0.22);
  border-top-color: rgba(250, 172, 38, 1);
  border-radius: 50%;
  animation: card-bind-indicator-spin 0.75s linear infinite;
}

@keyframes card-bind-indicator-spin {
  to {
    transform: rotate(360deg);
  }
}

// .card-item {
//   .card-bind-trigger {
//     cursor: pointer;
//     color: var(--primary-color, #faac26);
//     font-weight: 500;

//     &.is-loading {
//       cursor: not-allowed;
//     }
//   }
// }
</style>
